import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const precipitation: typeof valueTypeRenderers.precipitation = {
  label: () => unitConverter.precipitation().titleWithoutUnit(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.precipitation().title(),
      render: (n) => unitConverter.precipitation(n).valueAsString(),
    }),
}
